// extracted by mini-css-extract-plugin
module.exports = {"modalBody":"ModalBody_modalBody__1EK02","hasVerticalScrollbar":"ModalBody_hasVerticalScrollbar__13QLm"};